module.exports = __webpack_public_path__ + "img/caret-up.28457809.svg";